"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { resolveTeamverBranding, type TeamverBrandingConfig } from "./config";
import { TeamverBrandingHead } from "./TeamverBrandingHead";

const TeamverBrandingContext = createContext<TeamverBrandingConfig>({
  enabled: false,
  title: "teamver Slide",
  subtitle: "AI로 슬라이드·디자인 초안까지",
  faviconUrl: "/teamver/Logo-icon.svg",
  logoUrl: "/teamver/teamver-slide-light.png",
  logoUrlDark: "/teamver/teamver-slide-dark.png",
  navMarkUrl: "/teamver/Logo-icon.svg",
  heroTitle: "teamver Slide",
  heroSubtitle: "Create visual designs and layouts with AI from your workspace context.",
  hideExternalLinks: false,
  hideNavViews: new Set(),
  hideTopbarExecutionSwitcher: false,
  hideUseEverywhereChip: false,
  hideSettingsDialogLink: false,
  allowedSettingsSections: null,
  hideStudioExecutionControls: false,
  hideUsefulTips: false,
  hideHandoffButton: false,
  hideAssistantModelLabels: false,
  hideAssistantThinkingDetails: false,
  lockExecutionConfig: false,
  hideLocalWorkspaceControls: false,
  hideWorkspaceTabsBar: false,
  slideOnlyMvp: false,
  hideComposerIntegrations: false,
  hideCommunityGallery: false,
  hidePluginRegistry: false,
  hideExternalShareSurfaces: false,
  hideDrawAnnotation: false,
  hideManualEditBoxDrag: false,
  hideFileRevisionChrome: false,
});

export function TeamverBrandingProvider({ children }: { children: ReactNode }) {
  const branding = useMemo(() => resolveTeamverBranding(), []);
  return (
    <TeamverBrandingContext.Provider value={branding}>
      <TeamverBrandingHead />
      {children}
    </TeamverBrandingContext.Provider>
  );
}

export function useTeamverBranding(): TeamverBrandingConfig {
  return useContext(TeamverBrandingContext);
}
